import script from "./Shard.vue?vue&type=script&setup=true&lang=js"
export * from "./Shard.vue?vue&type=script&setup=true&lang=js"

import "./Shard.vue?vue&type=style&index=0&id=ccf0c256&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccf0c256"]])

export default __exports__